import { cn } from "@safers/ui";

export type ViewMode = "outside" | "xray" | "progress";

const MODES = ["outside", "xray", "progress"] as const;
const MODE_LABELS: Record<ViewMode, string> = {
  outside: "외관",
  xray: "X-Ray",
  progress: "공정",
};

interface ViewModeBarProps {
  mode: ViewMode;
  onModeChange: (m: ViewMode) => void;
  /** 위치 오버라이드. 기본은 하단 중앙. */
  className?: string;
}

const DEFAULT_POSITION = "absolute bottom-6 left-1/2 z-40 -translate-x-1/2";

export function ViewModeBar({
  mode,
  onModeChange,
  className = DEFAULT_POSITION,
}: ViewModeBarProps) {
  // 모드 세그먼트 바. 공정 모드는 오늘 날짜 기준으로 자동 적용(별도 컨텍스트 표시 없음).
  return (
    <div
      className={cn(
        "flex items-center gap-1 rounded-full border border-black/5 bg-white/85 px-1.5 py-1 shadow-lg backdrop-blur-md",
        className
      )}
    >
      {MODES.map((m) => (
        <button
          key={m}
          type="button"
          onClick={() => onModeChange(m)}
          className={cn(
            "rounded-full px-4 py-1.5 text-[0.8125rem] font-semibold transition",
            mode === m
              ? "bg-slate-900 text-white shadow"
              : "text-slate-500 hover:bg-black/5 hover:text-slate-800"
          )}
        >
          {MODE_LABELS[m]}
        </button>
      ))}
    </div>
  );
}
